export const filterOptionSwatchTemplate = `
<li
  data-action='{{ dataAction }}'
  class='boost-sd__filter-option-item boost-sd__filter-option-swatch-item'
>
  {% if swatchValue.text != nil %}
    {% assign valueLabel = swatchValue.text %}
  {% else %}
    {% assign valueLabel = value.label %}
  {% endif %}
  <button
    id='{{ actionId }}'
    data-action='{{ dataAction }}'
    title='Find product with {{ label | escape }} is {{ valueLabel | escape | strip_html }}. Number of products: {{ value.doc_count }}'
    role='checkbox'
    aria-checked='{% if classButton contains "boost-sd__filter-option-item-button--selected" %}true{% else %}false{% endif %}'
    class='{{classButton}}'
  >
    {% if swatchValue.backgroundColor == nil %}
      {% assign swatch_background_color = "none" %}
    {% else %}
      {% assign swatch_background_color = swatchValue.backgroundColor | strip_html %}
    {% endif %}
    {% if swatchValue.backgroundImage == nil %}
      {% assign swatch_background_image = "none" %}
    {% else %}
      {% assign swatch_background_image = swatchValue.backgroundImage | strip_html %}
    {% endif %}
    <span
      data-action='{{ dataAction }}'
      class='{{ className }}'
      style='background-color: {{ swatch_background_color }}; background-image: {{ swatch_background_image }}'
    ></span>
    
    {% assign swatchListStyle = option.swatchStyle == 'circle-list' or option.swatchStyle == 'square-list' %}
    {% if swatchListStyle %}
      <span data-action='{{ dataAction }}' class='boost-sd__filter-option-item-label'>
        {% if option.displayAllValuesInUppercaseForm %}
          {{ valueLabel | escape | upcase }}
        {% else %}
          {{ valueLabel | escape }}
        {% endif %}
      </span>
      {% if showDocCount %}
        <span
          data-action='{{ dataAction }}'
          role='text'
          aria-hidden='true'
          class='boost-sd__filter-option-item-amount'
          >({{ value.doc_count }})</span
        >
      {% endif %}
    {% endif %}
  </button>
</li>`;
